<!-- The following is a popup dialog to select a brand -->

<p-dialog appendTo="body" header="Brand Selection" [(visible)]="displayBrandDialog" [focusOnShow]="false"
        styleClass="wal-dialog"
        showEffect="fade" [modal]="true" [style]="{width: '45%'}" position="top"  [showHeader]="true" [closable]="false">

    <div class="grid">
        <div class="col-12">

            <p-table #dt [columns]="brandCols" [value]="brands" selectionMode="single" 
                [(selection)]="selectedBrand"  class="wal-table"
                sortMode="multiple" (onRowSelect)="onRowBrandSelect($event)" [paginator]="true" [rows]="15" >

              <ng-template pTemplate="header" let-columns>
                  <tr>

                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }

                </tr>
                  <tr>

                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width">
                            @switch (col.field) {
                                @case ('brandCode') {
                                    <input pInputText type="text"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                        [style.width]="'75%'"
                                    />
                                }
                                @case ('brandName') {
                                    <input pInputText type="text"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }

                </tr>  
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [pSelectableRow]="rowData" class="p-selectable-row p-highlight">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                    </tr>
              </ng-template>
            </p-table> 
      
        </div>
    </div>

    <div class="grid">
        @if(!isBrandGranted) {
            <label>{{noBrandWarning}}</label>
        }
<!-- 
        <div *ngIf="!isBrandGranted">
            <label>{{noBrandWarning}}</label>
        </div>
 -->
    </div>
            
    <ng-template #footer>

        <div class="footer-actions">

            @if(isBrandGranted) {
                <p-button label="Select" styleClass="p-button-success wal-success p-button-raised p-button-rounded 
                    margin-left" (click)="onBrandSelect()" [disabled]="isSelectDisabled">
                </p-button>
            }
            <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded 
                margin-left" (click)="onCancelBrandSelect()">
            </p-button>

            <div class="ui-g-2" id="idSpinner" [hidden]="isSpinnerHidden">
                <div class="loader"></div>  
            </div>
        </div>

    </ng-template>


</p-dialog>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="choose-brand"></p-confirmDialog>

